import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  customPath?: BreadcrumbItem[];
}

export default function BreadcrumbNav({ customPath }: BreadcrumbProps) {
  const location = useLocation();

  const getDefaultBreadcrumb = (): BreadcrumbItem[] => {
    const pathname = location.pathname;
    const parts = pathname.split('/').filter(Boolean);
    const items: BreadcrumbItem[] = [{ name: '首页', path: '/' }];

    if (parts.length === 0) return items;

    const pathMap: Record<string, string> = {
      category: '分类',
      article: '内容详情',
      about: '关于我们',
      movie: '电影',
      'tv-series': '电视剧',
      variety: '综艺',
      anime: '动漫',
      documentary: '纪录片',
      kids: '少儿',
    };

    let accumulated = '';
    parts.forEach((part) => {
      accumulated += `/${part}`;
      const displayName = pathMap[part] || part;
      items.push({ name: displayName, path: accumulated });
    });

    return items;
  };

  const items = customPath || getDefaultBreadcrumb();

  if (items.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-100/80 border-b border-background-200/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center">
                {index > 0 && (
                  <span className="mx-2 text-foreground-400" aria-hidden="true">
                    <i className="ri-arrow-right-s-line text-xs"></i>
                  </span>
                )}
                {!isLast && item.path ? (
                  <Link
                    to={item.path}
                    className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {item.name}
                  </Link>
                ) : (
                  <span className="text-foreground-800 font-medium whitespace-nowrap">
                    {item.name}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: item.path ? `https://www.xiguayingyuan.com${item.path}` : undefined,
          })),
        })}
      </script>
    </nav>
  );
}